import type { ComponentProps } from 'react'
import { useIntl } from 'react-intl'
import NavBarListItem from 'components/NavKit/NavBarListItem'
import NavBarListItemIcon from 'components/NavKit/NavBarListItemIcon'
import SolidSparklesIcon from 'LuxKit/Icons/solid/SolidSparklesIcon'
import useShouldUseChat from 'tripPlanner/hooks/useShouldUseChat'
import { CHAT_TRIP_PLANNER_ROUTE } from 'tripPlanner/pages/chat/ChatTripPlannerPage/hooks/useChatNavigation'

type InheritedListItemProps = Pick<ComponentProps<typeof NavBarListItem>, 'onClick'>

function AccountMenuAITripPlannerListItem(props: InheritedListItemProps) {
  const shouldUseChat = useShouldUseChat()

  if (!shouldUseChat) return null

  return <AccountMenuAITripPlannerListItemInner {...props} />
}

function AccountMenuAITripPlannerListItemInner(props: InheritedListItemProps) {
  const intl = useIntl()

  const aiTripPlannerText = intl.formatMessage({
    id: 'fy6AEDM2kmm0s1MZdp8w',
    defaultMessage: 'AI TripPlanner',
  })

  return (
    <NavBarListItem
      {...props}
      startIcon={<NavBarListItemIcon Icon={SolidSparklesIcon} colour="primary" />}
      title={aiTripPlannerText}
      to={CHAT_TRIP_PLANNER_ROUTE}
    />
  )
}

export default AccountMenuAITripPlannerListItem
